export default "__VITE_ASSET__a4a6cb23__"